import { Navigate, Outlet } from "react-router-dom";
import { PATIENT_TOKEN } from "./constants";

const PatientProtected = () => {
  const token = localStorage.getItem(PATIENT_TOKEN);

  return token ? <Outlet /> : <Navigate to="/patient-login" />;
};

export default PatientProtected;
